var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "tm-hero--bg tm-hero",
        style: {
          backgroundImage: "url('" + require("@/assets/guide-hero.png") + "')"
        }
      },
      [
        _vm._m(0),
        _c("img", {
          staticClass: "tm-hero__wave",
          attrs: {
            src: require("@/assets/hero-wave.svg"),
            alt: "",
            "aria-hidden": "true"
          }
        })
      ]
    ),
    _c("div", { staticClass: "tm-guide-container" }, [
      _c("div", { staticClass: "container pb-5 mb-5" }, [
        _c(
          "div",
          { staticClass: "row tm-guide-nav-container" },
          _vm._l(_vm.cards, function(card) {
            return _c(
              "div",
              {
                key: card.title,
                staticClass: "col-lg-3 col-6 mb-4 px-2 px-md-3 px-lg-2 px-xl-3"
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "tm-guide-card h-100",
                    attrs: { href: card.href }
                  },
                  [
                    _c("img", {
                      staticClass: "tm-guide-card__img",
                      attrs: { src: card.img, alt: card.title }
                    }),
                    _c("h2", { staticClass: "tm-guide-card__title" }, [
                      _vm._v(_vm._s(card.title))
                    ]),
                    _c("p", { staticClass: "tm-guide-card__description" }, [
                      _vm._v(_vm._s(card.description))
                    ])
                  ]
                )
              ]
            )
          }),
          0
        )
      ]),
      _c("div", { staticClass: "tm-zebra--odd" }, [
        _c("img", {
          staticClass: "tm-zebra__img",
          attrs: {
            src: require("@/assets/white-wave.svg"),
            alt: "",
            "aria-hidden": "true"
          }
        }),
        _c("div", { staticClass: "tm-zebra__foal tm-section" }, [
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              {
                staticClass: "row align-items flex-column-reverse flex-md-row"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-7 col-md-7 py-4 col-12 d-flex align-items-center"
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("h6", { staticClass: "tm-giant-subtitle" }, [
                          _vm._v("Developers")
                        ]),
                        _c(
                          "h4",
                          {
                            staticClass: "tm-giant-title font-weight-bold mb-5"
                          },
                          [_vm._v("Introducing our new API")]
                        ),
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "tm-btn tm-btn--primary tm-btn--round tm-btn--animated--rise",
                            attrs: { to: "/guide" }
                          },
                          [_vm._v("Read more   ")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._m(1)
              ]
            )
          ])
        ]),
        _c("img", {
          staticClass: "tm-zebra__img rotate-180",
          attrs: {
            src: require("@/assets/white-wave.svg"),
            alt: "",
            "aria-hidden": "true"
          }
        }),
        _c(
          "div",
          {
            staticClass: "tm-zebra__foal tm-section tm-section--padded--t-more"
          },
          [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("h2", { staticClass: "tm-section__title" }, [
                      _vm._v("Recent activity")
                    ]),
                    _vm._l(_vm.recentActivity, function(ra) {
                      return _c(
                        "div",
                        { key: ra.title, staticClass: "tm-recent-activity" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "tm-recent-activity__title",
                              attrs: { href: ra.href }
                            },
                            [_vm._v(_vm._s(ra.title))]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "tm-recent-activity__subtitle",
                              attrs: { href: ra.href }
                            },
                            [_vm._v(_vm._s(ra.subtitle))]
                          ),
                          _c(
                            "div",
                            { staticClass: "tm-recent-activity__activity" },
                            [
                              _c(
                                "span",
                                { staticClass: "tm-recent-activity__date" },
                                [_vm._v(_vm._s(ra.date))]
                              ),
                              _c(
                                "span",
                                { staticClass: "tm-recent-activity__comments" },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "tm-recent-activity__comments__icon material-icons-round",
                                      attrs: { "aria-hidden": "true" }
                                    },
                                    [_vm._v("chat_bubble_outline")]
                                  ),
                                  _c("span", [_vm._v(_vm._s(ra.comments))])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tm-hero__content container" }, [
      _c("h1", { staticClass: "tm-hero__title text-white mb-3 pb-3" }, [
        _vm._v("Hi, what can we help you with?")
      ]),
      _c("div", { staticClass: "tm-guide-hero__search" }, [
        _c(
          "i",
          {
            staticClass: "material-icons-round tm-guide-hero__search__icon",
            attrs: { "aria-hidden": "true" }
          },
          [_vm._v("search")]
        ),
        _c("input", {
          staticClass: "tm-guide-hero__search",
          attrs: { "aria-label": "Search", placeholder: "Search..." }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-lg-5 col-md-5 py-4 col-12 d-flex align-items-center justify-content-center"
      },
      [
        _c("img", {
          attrs: {
            id: "apiPic",
            src: require("@/assets/tamsin-io-black-api.svg"),
            alt: "tamsin.io api"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }